import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { fade, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AccountCircle from "@material-ui/icons/AccountCircle";
import DescriptionIcon from "@material-ui/icons/Description";
import FlightIcon from "@material-ui/icons/Flight";
import HomeIcon from "@material-ui/icons/Home";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import StorageIcon from "@material-ui/icons/Storage";
import axios from "axios";
import clsx from "clsx";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useRef
} from "react";
import { store as notificationStore } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useSound from "use-sound";
import { loadLiveNotifications } from "../actions/loadNotifications";
import socket from "../actions/socketIO";
import { COMPANY_SELECTING } from "../actions/types";
import boopSfx from "../assets/sounds/beep-01a.mp3";
import { IP } from "../config/IP";
import Logout from "./Logout";
import Notifications from "./Notifications";

const useStyles = makeStyles((theme) => ({
	icon: {
		borderRadius: "50%",
		width: 16,
		height: 16,
		boxShadow:
			"inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
		backgroundColor: "#f5f8fa",
		backgroundImage:
			"linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
		"$root.Mui-focusVisible &": {
			outline: "2px auto rgba(19,124,189,.6)",
			outlineOffset: 2,
		},
		"input:hover ~ &": {
			backgroundColor: "#ebf1f5",
		},
		"input:disabled ~ &": {
			boxShadow: "none",
			background: "rgba(206,217,224,.5)",
		},
	},
	checkedIcon: {
		backgroundColor: "#137cbd",
		backgroundImage:
			"linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
		"&:before": {
			display: "block",
			width: 16,
			height: 16,
			backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
			content: '""',
		},
		"input:hover ~ &": {
			backgroundColor: "#106ba3",
		},
	},
	grow: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
	search: {
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: fade(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: fade(theme.palette.common.white, 0.25),
		},
		marginRight: theme.spacing(2),
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(3),
			width: "auto",
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	inputRoot: {
		color: "inherit",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		width: "100%",
		[theme.breakpoints.up("md")]: {
			width: "20ch",
		},
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},

	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
}));
// Inspired by blueprintjs
function StyledRadio(props) {
	const classes = useStyles();

	return (
		<Radio
			className={classes.root}
			disableRipple
			color="default"
			checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
			icon={<span className={classes.icon} />}
			{...props}
		/>
	);
}

const PrimarySearchAppBar = forwardRef((props, ref) => {
	const classes = useStyles();
	const [play] = useSound(boopSfx);
	const token = localStorage.getItem("token");

	const notificationRef = useRef(null);
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
	const [showNotification, setShowNotification] = React.useState(false);
	const [notification, setNotification] = React.useState([]);
	const [totalNotification, setTotalNotification] = React.useState();

	let item = [];
	const [open, setOpen] = React.useState(false);
	const [selectedCompanyId, setSelectedCompanyId] = React.useState(
		state.companyData.selectedCompanyId
	);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const handleChangeSelectCompany = (event) => {
		console.log("handleChangeSelectCompany value=", event.target.value);
		setSelectedCompanyId(event.target.value);
		dispatch({ type: COMPANY_SELECTING, payload: event.target.value });
		handleClose();
	};
	const handleSaveSelectCompany = () => {
		console.log("handleSaveSelectCompany cliked");
	};
	const setNotificationFx = async (data) => {
		console.log("setNotificationFx in TopToolBar Data=", data);
		item = [];

		let photo = {};
		const config = {
			headers: {
				"x-auth-token": token,
				"content-type": "application/json",
			},
		};

		state.getNotications.notifications.NotificationResp.docs.map(async (x) => {
			let username = state.auth.user.allUser.find(
				(y) => y._id === x.receiverUsernameId
			).username;
			let output = await axios.get(
				IP.nodeServer + "api/profileimage/" + username,
				config
			);
			//.get(IP.nodeServer + "api/profileimage/olivier.komeza", config);
			console.log("return output=", output);
			if (output) {
				try {
					var buffer = Buffer.from(output.data.image.picture.data).toString(
						"base64"
					);

					photo = "data:image/png;base64," + buffer.toString(buffer);
				} catch (e) {
					photo = "person.png";
				}

				item.push({
					key: x._id,
					id: x.docId,
					createDate: x.createDate,
					readstatus: x.readstatus,
					readstatusDate: x.readstatusDate,

					username: username,
					message: x.message,
					photo: photo,
				});

				/*NotificationResp:
		createDate: "2020-05-12T17:07:15.395Z"
		createdAt: "2020-05-12T17:07:15.397Z"
		docId: "5ebad789df6a98206030e9d8"
		emailNotify: false
		emailNotifyDate: "2020-05-12T17:07:15.395Z"
		message: "have  approved the document"
		readstatus: false
		readstatusDate: "2020-05-12T17:07:15.395Z"
		receiverOffice_id: 57
		receiverUsernameId: "5dff3eae53e36604087cb2ac"
		senderOffice_id: 670
		senderUsernameId: "5dff3eae53e36604087cb2ac"

		*/
			}
		});
		setNotification(item);

		console.log("TopToolBar item=", item);
	};


	const isMenuOpen = Boolean(anchorEl);
	const [popupStateValue, setPopupStateValue] = React.useState();

	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
	const onClickToogle = () => {
		try {
			var aside = document.querySelector(".side-nav");
			var showAsideBtn = document.querySelector(".show-side-btn");
			var contents = document.querySelector("#contents");
			document
				.querySelector("#show-side-navigation1")
				.classList.toggle("show-side-nav");
			contents.classList.toggle("margin");
		} catch (e) {
			console.log("Dashboard showAsideBtn.addEventListener error 1=", e);
		}
	};

	const showNotificationFx = () => {
		console.log("Oka showNotification=", showNotification);
		//setShowNotification(!showNotification);

		notificationStore.addNotification({
			id: "First",
			title: "Wonderful!",
			message: "teodosii@react-notifications-component",
			type: "success",
			insert: "top",
			container: "top-right",
			showIcon: true,
			onRemoval: (id, removedBy) => {
				console.log("notification store id=", id);
			},
		});
		notificationStore.addNotification({
			id: "Second",
			title: "Wonderful!",
			message: "<div>oka no issue</div>",
			type: "danger",
			insert: "top",
			container: "top-right",
			showIcon: true,
			onRemoval: (id, removedBy) => {
				console.log("notification store id=", id);
			},
		});
	};

	const handleProfileMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		handleMobileMenuClose();
	};

	const handleMobileMenuOpen = (event) => {
		setMobileMoreAnchorEl(event.currentTarget);
	};
	useImperativeHandle(ref, () => {
		return {
			setNotificationFx: setNotificationFx,
			setTotalNotification: (value) => {
				console.log("setTotalNotification value=", value);

				setTotalNotification(value);
			},
		};
	});
	useEffect(() => {
		setSelectedCompanyId(state.companyData.selectedCompanyId);
	}, [state.companyData]);
	useEffect(() => {
		try {
			console.log("notification.length=", notification.length);
		} catch (e) { }
	}, [notification, setNotification]);

	useEffect(() => {
		console.log("popupState=", popupStateValue);
	}, [popupStateValue, setPopupStateValue]);

	useEffect(() => {
		socket.on("Notifications", (data) => {
			console.log("from socket io on Notifications=", data);
			try {
				//ref.current.setNotificationFx(data);
				if (!state.getNotications.isLoading && !state.getNotications.isLoaded) {
					dispatch(loadLiveNotifications(data));
				}
			} catch (e) {
				//console.error("from socket io on Notifications error=", e);
			}
		});

	}, []);

	useEffect(() => {
		if (state.getNotications.isLoaded) {
			try {
				ref.current.setTotalNotification(
					state.getNotications.notifications.NotificationResp.total
				);
			} catch (e) { }
		}
	}, [state.getNotications.isLoaded]);

	const menuId = "primary-search-account-menu";
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem onClick={handleMenuClose}>Profile</MenuItem>
			<MenuItem onClick={handleMenuClose}>My account</MenuItem>
		</Menu>
	);

	const mobileMenuId = "primary-search-account-menu-mobile";
	const renderMobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMobileMenuOpen}
			onClose={handleMobileMenuClose}
		>
			<MenuItem>
				<IconButton aria-label="show 4 new mails" color="inherit">
					<Badge badgeContent={4} color="secondary">
						<MailIcon />
					</Badge>
				</IconButton>
				<p>Messages</p>
			</MenuItem>
			<MenuItem>
				<IconButton aria-label="show 11 new notifications" color="inherit">
					<Badge badgeContent={11} color="secondary">
						<NotificationsIcon />
					</Badge>
				</IconButton>
				<p>Notifications</p>
			</MenuItem>
			<MenuItem onClick={handleProfileMenuOpen}>
				<IconButton
					aria-label="account of current user"
					aria-controls="primary-search-account-menu"
					aria-haspopup="true"
					color="inherit"
				>
					<AccountCircle />
				</IconButton>
				<p>Profile</p>
			</MenuItem>
		</Menu>
	);
	let companyName = "";
	try {
		companyName = state.companyData.allCompany.find(
			(x) => x._id === selectedCompanyId
		).companyName;
	} catch (e) { }

	//if (!item.length) return "loading";

	return (
		<div className={classes.grow}>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">Company</DialogTitle>
				<DialogContent>
					<DialogContentText>
						To select a Company, to work for on below options
					</DialogContentText>
					<FormControl component="fieldset">
						<FormLabel component="legend">Company</FormLabel>
						<RadioGroup
							defaultValue={
								state.companyData?.allCompany.length > 0
									? state.companyData.allCompany[0]._id
									: null
							}
							aria-label="gender"
							name="selectedCompany"
							onChange={handleChangeSelectCompany}
						>
							{state.companyData ?
								Array.isArray(state.companyData?.allCompany) ?
									state.companyData?.allCompany?.map((x) => {
										return (
											<FormControlLabel
												value={x._id}
												control={<StyledRadio />}
												label={x.companyName}
											/>
										);
									}) : <></> : <></>}
						</RadioGroup>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
				</DialogActions>
			</Dialog>
			<AppBar position="static">
				<Toolbar>
					<IconButton
						edge="start"
						className={classes.menuButton}
						color="inherit"
						aria-label="open drawer"
						onClick={onClickToogle}
					>
						<MenuIcon />
					</IconButton>
					<Typography className={classes.title} variant="h6" noWrap>
						<a className="navbar-brand" href="#">
							my
							<span className="main-color">
								Work {companyName ? `(${companyName})` : ""}
							</span>
							{selectedCompanyId && (
								<font onClick={handleClickOpen}>Change</font>
							)}
						</a>
					</Typography>
					<div className={classes.grow} />
					<div className={classes.sectionDesktop}></div>
					<div className={classes.sectionMobile}></div>
					<Link to="/">
						<Tooltip title="Home" aria-label="Home">
							<IconButton aria-label="home" color="inherit">
								<HomeIcon />
							</IconButton>
						</Tooltip>
					</Link>
					<Link to="/document">
						<Tooltip title="Document" aria-label="Document">
							<IconButton
								aria-label="show 17 new notifications"
								color="inherit"
							>
								<DescriptionIcon />
							</IconButton>
						</Tooltip>
					</Link>
					{false && (
						<PopupState variant="popover" popupId="demo-popup-popover">
							{(popupState) => {
								//setPopupStateValue(popupState);

								console.log("popupState=", popupState.isOpen);
								if (popupState.isOpen) {
									console.log("TopToolBar notification=", notification);
									let counter = 0;
									socket.emit(
										"readNotifications",
										notification.map((x, index) => {
											if (x.readstatus === false) {
												counter = index + 1;
												return x.key;
											}
										})
									);
									if (counter > 0) {
										//socket.emit("Notifications");
									}
									//
								} else {
								}

								return (
									<div>
										<Tooltip title="Notifications" aria-label="Notifications">
											<IconButton
												aria-label="show new notifications"
												color="inherit"
												/*onClick={() => {
											showNotificationFx();
										}}
										*/
												{...bindTrigger(popupState)}

											/*onClick={() => {
											console.log("TopToolBar notification=", notification);
											socket.emit(
												"readNotifications",
												notification.map((x) => {
													if (x.readstatus === false) {
														return x.key;
													}
												})
											);
											socket.emit("Notifications");
											
										}}
									*/
											>
												<Badge
													badgeContent={totalNotification}
													color="secondary"
												>
													<NotificationsIcon />
												</Badge>
											</IconButton>
										</Tooltip>

										<Popover
											{...bindPopover(popupState)}
											anchorOrigin={{
												vertical: "bottom",
												horizontal: "center",
											}}
											transformOrigin={{
												vertical: "top",
												horizontal: "center",
											}}
										>
											<Box p={2}>
												<Notifications
													ref={notificationRef}
													item={notification}
												/>
											</Box>
										</Popover>
									</div>
								);
							}}
						</PopupState>
					)}{" "}
					{false && (
						<Link to="/Shop">
							<Tooltip title="Shop" aria-label="Shop">
								<IconButton aria-label="saff travel" color="inherit">
									<StorageIcon />
								</IconButton>
							</Tooltip>
						</Link>
					)}
					<Link to="/StaffTravel">
						<Tooltip title="Staff Travel" aria-label="StaffTravel">
							<IconButton aria-label="saff travel" color="inherit">
								<FlightIcon />
							</IconButton>
						</Tooltip>
					</Link>
					<Link to="/notification">
						<Tooltip title="Notifications" aria-label="Notifications">
							<IconButton
								aria-label="show 17 new notifications"
								color="inherit"
							>
								<Badge badgeContent={totalNotification} color="secondary">
									<NotificationsIcon />
								</Badge>
							</IconButton>
						</Tooltip>
					</Link>
					<Tooltip title="Logout" aria-label="Logout">
						<Logout />
					</Tooltip>
				</Toolbar>
			</AppBar>
		</div>
	);
});
export default PrimarySearchAppBar;
